export const POST_AUTH_REDIRECT_URL_KEY = 'postAuthRedirectURL';

export const savePostAuthRedirectURL = () => {
  if (typeof window === 'undefined') return;

  sessionStorage.setItem(POST_AUTH_REDIRECT_URL_KEY, window.location.href);
};

export const getPostAuthRedirectURL = () => sessionStorage.getItem(POST_AUTH_REDIRECT_URL_KEY);

export const deletePostAuthRedirectURL = () => {
  sessionStorage.removeItem(POST_AUTH_REDIRECT_URL_KEY);
};
